import React from 'react'
import styled, { css } from 'styled-components/macro'
import { color } from 'styled-system'
import palette from 'src/designSystem/variables/palette'
import themeGet from '@styled-system/theme-get'
import { BadgeErrorSVG, ErrorSVG } from '../../Icons/Basic'

export const EditableOnClickWarning = styled.p`
  margin: auto;
  overflow: hidden;
`

export const EditableOnClickWarningContainer = styled.div.attrs({
  color: 'fill.status.error.dark',
})`
  ${color}
  display: flex;
  flex-direction: row;
  margin: auto;
  font-size: 14px;
  gap: 5px;
`

export const ErrorSVGforWarning = styled(ErrorSVG).attrs({
  fill: 'fill.status.error.dark',
})`
  ${color}
  height: 16px;
  min-height: 16px;
  width: 16px;
  min-width: 16px;
  margin: auto;
`

export const EditableOnClickContainer = styled.div<{
  inline?: boolean
  isEditing?: boolean
  isEmpty?: boolean
  isDisabled?: boolean
  autoWidth?: boolean
}>`
  width: ${({ autoWidth }) => (autoWidth ? 'auto' : '100%')};
  ${({ inline, isEditing }) => {
    if (inline) {
      return css`
        display: flex;
        align-items: center;
        * {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        ${isEditing &&
        css`
          margin-bottom: 16px;
        `}
      `
    }
  }}
  ${({ isEditing, isDisabled }) => {
    if (!isEditing && !isDisabled) {
      return css`
        :hover,
        :focus {
          background-color: ${themeGet('colors.bg.neutral')};
        }
      `
    }
  }}
${({ isEditing, isEmpty }) => {
    if (!isEditing && isEmpty) {
      return css`
        height: 40px;
      `
    }
  }}
`

export const ButtonGroupContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: flex-start;
`

export const ButtonGroup = styled.div<{ inline?: boolean }>`
  display: inline-flex;
  ${(props) => {
    if (props.inline) {
      return css`
        align-self: center;
        margin-left: ${themeGet('space.xs')}px;
      `
    }
    return css`
      margin: ${themeGet('space.xs')}px;
    `
  }}

  > :not(:last-child) {
    margin-right: ${themeGet('space.xs')}px;
  }
`

export const EditOnClickError = styled.div`
  margin: 0 0 8px 8px;
  font-size: 14px;
  color: ${palette.magenta[600]};
`

// styled component p tag that has the value of 'None'
export const EditOnClickNone = styled.div.attrs(() => ({
  children: <p>None</p>,
}))`
  p {
    margin: 0;
    font-size: 14px;
    color: ${palette.neutral[600]};
  }
`

export const WarningIcon = styled(BadgeErrorSVG)`
  height: 16px;
  width: 16px;
  margin-bottom: 3px;
`

export const Container = styled.div<{ isFullHeight?: boolean }>`
  position: relative;
  display: inline-block;
  width: 100%;
  ${({ isFullHeight }) =>
    isFullHeight &&
    css`
      height: 100%;
      display: flex;
      flex-direction: column;
    `}
`

export const ViewMode = styled.div<{ allowEdit: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  cursor: ${({ allowEdit }) => (allowEdit ? 'pointer' : 'default')};
  transition: background-color 0.2s ease;
  width: 100%;

  ${({ allowEdit }) =>
    allowEdit &&
    `
    &:hover {
      background-color: ${palette.neutral[30]};
    }
  `}
`

export const EditMode = styled.div`
  display: flex;
  flex-direction: column;
`

export const MarkdownEditMode = styled.div<{ isFullHeight?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${({ isFullHeight }) =>
    isFullHeight &&
    css`
      flex: 1;
      min-height: 0;
    `}
`

export const EditButton = styled.button`
  background-color: transparent;
  padding: 4px 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: none;
  border-radius: 4px;

  &:hover {
    background-color: ${palette.neutral[100]};
  }
`
export const PlaceholderText = styled.div`
  width: 100%;
  color: ${palette.neutral['400']};
`

export const FullWidthMessageWrapper = styled.div`
  width: 100%;

  > div {
    width: 100% !important;
  }
`

export const ReactMdeWrapper = styled.div<{ isFullHeight?: boolean }>`
  .react-mde {
    border-radius: 20px;
    overflow: hidden;
    padding: 5px;
    background: white;

    .mde-header {
      background: none;
    }

    textarea {
      border: none;
      outline: none;
    }

    &:hover,
    &:focus-within {
      background: white;
    }

    .mde-suggestions {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid ${palette.neutral[100]};
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      background: white;

      li {
        padding: 8px 12px;
        font-size: 13px;
        color: ${palette.neutral[800]};

        &:hover,
        &[aria-selected='true'] {
          background: ${palette.neutral[50]};
          color: ${palette.neutral[600]};
        }
      }
    }
  }
  ${({ isFullHeight }) =>
    isFullHeight &&
    css`
      flex: 1;
      min-height: 0;

      > div {
        height: 100%;
        display: flex;
        flex-direction: column;

        > div:nth-child(2) {
          flex: 1;
          display: flex;
          flex-direction: column;

          .mde-textarea-wrapper {
            flex: 1;

            textarea {
              min-height: 100px;
            }
          }
        }
      }
    `}
`
